import Step from './Step';
import Steps from './Steps';
Steps.Step = Step;
export default Steps;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-steps/src/index.js